import { useTheme } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import SearchIcon from '@mui/icons-material/Search';
import { ChangeEvent, ChangeEventHandler } from 'react';
import { SortDropdown } from './SortDropdown';
import { SortOption } from '../profile/ProfileBottomSection';
import { FilterSaleType, FilterSaleTypeProps } from './FilterSaleType';

type SearchBarProps = {
  searchQuery: string;
  handleSearchChange: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  >;
};

function SearchBar({ searchQuery, handleSearchChange }: SearchBarProps) {
  const theme = useTheme();
  const background = theme.palette.background.elevationSolid[8];
  //TODO: implement searchbar functionality
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        border: 'double 1px transparent',
        borderRadius: '5px',
        backgroundImage: `linear-gradient(${background}, ${background}), linear-gradient(180deg, #4DC8FF 0%, #0064E9 100%)`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        height: '40px',
        zIndex: 2,
        flexGrow: 1,
        boxShadow: theme.shadowsHard.primaryElevation1,
      }}
    >
      <SearchIcon sx={{ ml: 2 }} />
      <InputBase
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Search..."
        sx={{
          flex: 1,
          color: theme.palette.text.secondary,
          ml: 1,
          height: '100%',
        }}
      />
    </Box>
  );
}

type SearchAndSortProps = {
  searchQuery: string;
  sortOptions: SortOption[];
  currentSortOption: SortOption;
  handleSearchChange: (e: ChangeEvent<HTMLElement>) => void;
  handleSortChange: (e: SelectChangeEvent) => void;
} & FilterSaleTypeProps;

export function SearchAndSort({
  searchQuery,
  sortOptions,
  currentSortOption,
  handleSearchChange,
  handleSortChange,
  select,
  selectedSaleType,
}: SearchAndSortProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        width: '100%',
      }}
    >
      <Box sx={{ width: '100%' }}>
        <SearchBar
          searchQuery={searchQuery}
          handleSearchChange={handleSearchChange}
        />
      </Box>
      <FilterSaleType select={select} selectedSaleType={selectedSaleType} />
      <SortDropdown
        currentSortOption={currentSortOption}
        handleSortChange={handleSortChange}
        sortOptions={sortOptions}
      />
    </Box>
  );
}
